export default {
  fields: {
    sales: {
      label: 'Vânzări',
    },
    gift_cards_sales: {
      label: 'Vânzări carduri cadou',
    },
    average_order_value: {
      label: 'Valoare medie comandă',
    },
    savings: {
      label: 'Economii la comisioane terțe',
    },
    reservations: {
      label: 'Rezervări',
    },
    sales_from_email: {
      label: 'Vânzări din e-mail',
    },
    sales_from_google_seo: {
      label: 'Vânzări din Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Vânzări din Google Business',
    },
    sales_from_google_ads: {
      label: 'Vânzări din Google Ads',
    },
    sales_from_flyers: {
      label: 'Vânzări din flyere',
    },
    sales_from_social_media: {
      label: 'Vânzări din rețele sociale',
    },
    sales_from_facebook_ads: {
      label: 'Vânzări din Facebook Ads',
    },
    tips: {
      label: 'Bacșișuri',
    },
    new_customers: {
      label: 'Clienți noi',
    },
    returning_customers: {
      label: 'Clienți recurenți',
    },
    new_visitors: {
      label: 'Vizitatori noi',
    },
    new_followers: {
      label: 'Urmăritori noi',
    },
    total_followers: {
      label: 'Total urmăritori',
    },
    delivered_messages: {
      label: 'Mesaje livrate',
    },
    average_open_rate: {
      label: 'Rată medie deschidere e-mail',
    },
    average_click_rate: {
      label: 'Rată medie de clic',
    },
    website_visitors_from_email: {
      label: 'Vizitatori site din e-mail',
    },
    sales_from_google_business: {
      label: 'Vânzări din Google Business',
    },
    total_reservations: {
      label: 'Rezervări',
    },
    website_visitors_from_google_seo: {
      label: 'Clicuri site din Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Clicuri site din Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Clicuri site din Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Clicuri site din rețele sociale',
    },
    calls_from_google_ads: {
      label: 'Apeluri din Google Ads',
    },
    directions_from_google_ads: {
      label: 'Direcții din Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Rețele sociale',
    },
    flyer_orders_count: {
      label: 'Flyere',
    },
    email_orders_count: {
      label: 'E-mailuri',
    },
    other_orders_count: {
      label: 'Altele',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Carduri cadou',
    },
    net_billed_revenue: {
      label: 'Venituri facturate (NET)',
    },
    net_billed_revenue_subscription: {
      label: 'Venituri abonamente facturate',
    },
    net_billed_revenue_service_fee: {
      label: 'Venituri comision servicii facturate',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Venituri facturate din taxe de livrare',
    },
    net_billed_revenue_other: {
      label: 'Venituri facturate din taxe de serviciu',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Livrare facturată - Pass-through',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Venituri facturate din taxe de procesare platformă',
    },
    gross_cash_income: {
      label: 'Venituri numerar (Brut)',
    },
    gross_cash_income_subscription: {
      label: 'Venituri numerar din abonamente',
    },
    gross_cash_income_service_fee: {
      label: 'Venituri numerar din comisioane de servicii',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Venituri numerar din taxe de livrare',
    },
    gross_cash_income_other: {
      label: 'Venituri numerar din tarife de serviciu',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Venituri numerar din taxe livrare pass-through',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Venituri numerar din taxe procesare platformă',
    },
    net_cash_income: {
      label: 'Venituri numerar (NET)',
    },
    net_cash_income_subscription: {
      label: 'Venituri numerar din abonamente',
    },
    net_cash_income_service_fee: {
      label: 'Venituri numerar din comisioane de servicii',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Venituri numerar din taxe de livrare',
    },
    net_cash_income_other: {
      label: 'Venituri numerar din tarife de serviciu',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Venituri numerar din taxe livrare pass-through',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Venituri numerar din taxe procesare platformă',
    },
    manual_connect_transfers: {
      label: 'Rambursări către restaurante',
    },
    processing_fees: {
      label: 'Taxe de procesare',
    },
    processing_fees_stripe: {
      label: 'Taxe de procesare (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Taxe de procesare (PayPal)',
    },
    rejected_orders: {
      label: 'Comenzi respinse',
    },
    rejected_orders_amount: {
      label: 'Valoare comenzi respinse',
    },
    rejected_orders_count: {
      label: 'Număr comenzi respinse',
    },
    rejected_orders_rate: {
      label: 'Rată comenzi respinse',
    },
    rejected_orders_rate_breakdown: {
      label: 'Detaliu rată comenzi respinse',
    },
    orders: {
      label: 'Comenzi',
    },
    total_orders: {
      label: 'Total comenzi',
    },
    pickup_orders_rate: {
      label: 'Rată comenzi cu ridicare',
    },
    delivery_orders_rate: {
      label: 'Rată comenzi cu livrare',
    },
    other_orders_rate: {
      label: 'Rată alte comenzi',
    },
    customers: {
      label: 'Total clienți',
    },
    customers_auth_state: {
      label: 'Stare autentificare clienți',
    },
    website_reservations: {
      label: 'Rezervări website',
    },
    google_reservations: {
      label: 'Rezervări Google',
    },
    companies: {
      label: 'Companii',
    },
    live_companies: {
      label: 'Restaurante active',
    },
    live_companies_percentage: {
      label: 'Procent restaurante active',
    },
    setup_packages_breakdown: {
      label: 'Pachete de configurare',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Pachete configurare după sursă facturare',
    },
    crossed_sales_level_this_month: {
      label: 'Nivel vânzări atins luna aceasta',
    },
    crossed_sales_level_total: {
      label: 'Nivel vânzări atins total',
    },
    crossed_sales_level_percentage: {
      label: 'Procent nivel vânzări atins',
    },
    has_delivery: {
      label: 'Livrare proprie',
    },
    has_only_pickup: {
      label: 'Doar ridicare',
    },
    has_storefront: {
      label: 'Are vitrină online',
    },
    has_storefront_percentage: {
      label: 'Procent vitrină online',
    },
    use_external_delivery: {
      label: 'Livrare externă',
    },
    crossed_sales: {
      label: 'Depășit {{value}} vânzări',
    },
    restaurant_partners: {
      label: 'Restaurante partenere',
    },
    registered_restaurants: {
      label: 'Restaurante înregistrate',
    },
    signed_restaurants: {
      label: 'Restaurante semnate',
    },
    use_reservations: {
      label: 'Utilizează rezervări',
    },
    number: {
      label: 'Număr',
    },
    restaurants_percentage: {
      label: 'Procent restaurante',
    },
    crossed_sales_level: {
      label: 'Nivel vânzări atins',
    },
    order_method: {
      label: 'Metodă de comandă',
    },
    own_delivery: {
      label: 'Livrare proprie',
    },
    only_pickup: {
      label: 'Doar ridicare',
    },
    storefront: {
      label: 'Vitrină online',
    },
    sales_tiers: {
      label: 'Niveluri de vânzări',
    },
    new_pricing_adoption_rate: {
      label: 'Rată adoptare preț nou',
    },
    mobile_app_attach_rate: {
      label: 'Rată atașare aplicație mobilă',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Taxe configurare aplicație mobilă alese',
    },
    first_delivery: {
      label: 'Uber (Prima livrare)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Număr oferte livrare',
    },
    deliveries_count: {
      label: 'Număr livrări',
    },
    delivery_conversion: {
      label: 'Rată conversie livrare',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Detaliu oferte livrare pe furnizori',
    },
    deliveries_provider_breakdown: {
      label: 'Detaliu livrări pe furnizori',
    },
    delivery_distance_breakdown: {
      label: 'Detaliu distanță livrare',
    },
    total_delivered: {
      label: 'Mesaje livrate',
    },
    website_visitors_from_google_business_profile: {
      label: 'Clicuri website din Google Business',
    },
    google_business_impressions: {
      label: 'Afișări din Google Business',
    },
    google_business_website_clicks: {
      label: 'Clicuri website din Google Business',
    },
    google_ads_impressions: {
      label: 'Afișări Google Ads',
    },
    google_ads_clicks: {
      label: 'Clicuri Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Apeluri Google Ads',
    },
    google_ads_directions: {
      label: 'Indicații Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: 'Procent mediu afișare top absolut Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Cost mediu pe clic Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Rată medie conversii din interacțiuni Google Ads',
    },
    website_visits: {
      label: 'Vizite website',
    },
    website_visitors: {
      label: 'Vizitatori website',
    },
    companies_with_activated_reservations: {
      label: 'Restaurante cu rezervări activate',
    },
    online_orders_count: {
      label: 'Comenzi online',
    },
    cash_orders_count: {
      label: 'Comenzi online',
    },
    cash_sales: {
      label: 'Vânzări numerar',
    },
    online_sales: {
      label: 'Vânzări online',
    },
    payouts: {
      label: 'Plăți',
    },
    last_payout_amount: {
      label: 'Ultima plată',
    },
    pending_payout_amount: {
      label: 'În tranzit',
    },
    future_payout_amount: {
      label: 'Disponibil pentru plăți viitoare',
    },
    mobile_app_average_order_value: {
      label: 'AOV prin aplicație',
    },
    mobile_app_gmv: {
      label: 'Total vânzări prin aplicație',
    },
    mobile_app_gmv_percentage: {
      label: '% venituri din aplicație',
    },
    mobile_app_downloads: {
      label: 'Total descărcări aplicație',
    },
    mobile_app_orders_count: {
      label: 'Total comenzi prin aplicație',
    },
    net_billed_revenue_gift_cards: {
      label: 'Venituri facturate din carduri cadou',
    },
    gross_cash_income_gift_cards: {
      label: 'Venituri numerar din carduri cadou',
    },
    net_cash_income_gift_cards: {
      label: 'Venituri numerar din carduri cadou',
    },
    platform_processing_fees: {
      label: 'Taxe de procesare platformă',
    },
  },
};
